<script>
import { mapGetters, mapActions } from 'vuex'

import Layout from '@layouts/main.vue'
import PageHeader from '@components/page-header.vue'
import Bill from '@components/bill.vue'
import BillSummary from '@components/bill-summary.vue'
import PaymentDropin from '@components/payment-dropin.vue'

import { pricify } from '@utils/currency'

export default {
  page: {
    title: 'Success',
    meta: [{ name: 'description', content: '' }],
  },
  components: {
    Layout,
    PageHeader,
    Bill,
    BillSummary,
    PaymentDropin,
  },
  computed: {
    ...mapGetters({
      accountId: 'payment/getAccountId',
      braintreeToken: 'payment/getBraintreeToken',
      emailAddress: 'payment/getEmailAddress',
      items: 'payment/getItems',
      location: 'location/getLocation',
      selectedItems: 'payment/getSelectedItems',
      selectedTotal: 'payment/getSelectedTotal',
      serviceCharge: 'payment/getServiceCharge',
      splitServiceCharge: 'payment/getSplitServiceCharge',
      splitBill: 'payment/getSplitBill',
      tableNumber: 'payment/getTableNumber',
      tip: 'payment/getTip',
      total: 'payment/getTotal',
    }),
    computedSubtotal() {
      const total = parseFloat(this.selectedTotal || this.total)
      const serviceCharge = parseFloat(
        this.splitServiceCharge || this.serviceCharge || 0
      )
      const tip = parseFloat(this.tip || 0)
      const subtotal = total + serviceCharge + tip
      return pricify(subtotal)
    },
  },
  beforeMount() {
    this.checkForData()
  },
  methods: {
    ...mapActions({
      checkForData: 'payment/checkForData',
    }),
  },
}
</script>

<template>
  <Layout v-if="items" screen="payment">
    <PageHeader :page="3" title="Select your payment option" />
    <div :class="$style.container">
      <BillSummary
        :amount="items && items.length"
        :order-number="accountId"
        :selected-total="selectedTotal"
        :selected-items="selectedItems"
        :service-charge="serviceCharge"
        :split-service-charge="splitServiceCharge"
        :table-number="tableNumber"
        :tip="tip"
        :total="total"
      />
      <Bill
        :class="$style.padding"
        :collapsable="true"
        :items="
          selectedItems
            ? items.filter((item, index) => selectedItems.includes(index))
            : items
        "
        :selected-total="selectedTotal"
        :service-charge="serviceCharge"
        :split-bill="false"
        :split-service-charge="splitServiceCharge"
        :tip="tip"
        :title="splitBill ? 'Selected items' : 'Your items'"
        :total="total"
      />
      <div :class="$style.paymentOptions">
        <h4>Select your payment method</h4>
        <PaymentDropin
          :braintree-token="braintreeToken"
          :location="location"
          :table-number="tableNumber"
          :total="computedSubtotal"
        />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.container {
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 12px 0 48px;

  > * {
    width: 100%;
  }
}

.padding {
  padding: 1rem 2rem;
}

.paymentOptions {
  padding: 10px 20px 40px;
  display: flex;
  flex-direction: column;

  > * {
    width: 100%;
    margin: 6px;
  }
}

.googlePayTemp {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-radius: 5px;
  padding: 0;
  box-sizing: border-box;
  min-width: 200px;
  min-height: 32px;
  max-height: 64px;
  background-color: #111111;
  color: white;
  cursor: pointer;
  user-select: none;
}
</style>
